import { Button, Input, Modal, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaCalendar, FaFire } from "react-icons/fa";
import { addComponent } from "../../../../../../../Utils/SupabaseServices/StayUpToDateDatabase";
import { getMaxTrendingCount } from "../../../../../../../Utils/SupabaseServices/AnalyticsDatabse";
import dayjs from "dayjs";
import '../../../../../../../components/CheckboxComponent/FeedCheckboxComponent.css'
import '../../../../../../../components/StayUpToDateComponent/StayUpToDate.css'
import CustomDateRange from "../../../../../../../components/CustomDateRange/CustomDateRange";
import { ModalBackButton } from "../../../../../../../components/EditModalComponents.tsx/ModalBackButton";
import { validateShopLinksTitle } from "../../../../../../../Utils/helpers/carouselHelper";
import { useLoadTrendingProducts } from "../../../../../../../Utils/customHooks/UpToDateContent/useLoadTrendingProducts";
import { getCustomDateRange } from "../../../../../../../Utils/HelperFunction/HelperFunction";
import PreviewComponent from "../PreviewComponent";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const { Title, Text } = Typography;

// Styles for the section headers and helper text
const sectionStyle = {
  marginBottom: '8px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const helperTextStyle = {
  color: '#666',
  fontSize: '14px',
  marginBottom: '16px',
};

const TrendingProductsComponent = (props: any) => {
  const {
    isTrendingProductsModalOpen,
    user_id,
    username,
    setIsShoplinksModalOpen,
    from
  } = props;

  const name = "Trending Products";
  const cta = "Check it out!";
  const [clickNumber, setClickNumber] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [fileList, setFileList] = useState<any>([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [maxCount, setMaxCount] = useState<any>();
  const [isCustomDateModalOpen, setIsCustomDateModalOpen] = useState(false); // State for the custom date modal
  const [customStartDate, setCustomStartDate] = useState<any>("");
  const [customEndDate, setCustomEndDate] = useState<any>("");
  const [selectedDates, setSelectedDates] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | null
  >(null);
  const [days, setDays] = useState<any>("");

  useEffect(() => {
    fetchMaxCount();
  }, [clickNumber]);

  async function fetchMaxCount() {
    const res = await getMaxTrendingCount(username, user_id);
    setMaxCount(res);
  }

  const [activeTab, setActiveTab] = useState(2);

  const { isLoading: TrendingProductsLoading, data: TrendingProducts }: any =
    useLoadTrendingProducts(
      user_id,
      username,
      name,
      clickNumber,
      "",
      getCustomDateRange(activeTab, customStartDate, customEndDate).startDate,
      getCustomDateRange(activeTab, customStartDate, customEndDate).endDate,
      days,
      true
    );


  const handleOk = async () => {
    // Validate title against reserved content carousel titles 
    const validation = validateShopLinksTitle(name, "trending products");
    if (!validation.isValid) {
      setErrorMsg(validation.error || "Invalid title");
      return;
    }

    let startDate: any;
    let endDate: any;

    if (activeTab !== 1 && activeTab !== 2) {
      endDate = dayjs().tz(userTimezone).utc().add(1, "day").format("YYYY-MM-DD");
      startDate = dayjs().tz(userTimezone).utc().subtract(activeTab, "day").format("YYYY-MM-DD");
    } else {
      if (activeTab === 2) {
        endDate = dayjs().tz(userTimezone).utc().add(1, "day").format("YYYY-MM-DD");
        startDate = dayjs().tz(userTimezone).utc().subtract(100000, "day").format("YYYY-MM-DD");
      } else {
        startDate = customStartDate.tz(userTimezone).utc().format("YYYY-MM-DD");
        endDate = customEndDate.tz(userTimezone).utc().add(1, "day").format("YYYY-MM-DD");
      }
    }

    setConfirmLoading(true);
    const res = await addComponent(
      name,
      `${clickNumber},${startDate},${endDate},${activeTab}`,
      username,
      user_id,
      "false",
      cta,
      "",
      name,
      "trending products",
      "",
      "DESC",
      "rect",
      false,
      undefined,
      from
    );
    if (res === "true") {
      props.refetch();
      props.setIsTrendingProductsModalOpen(false);
      setIsShoplinksModalOpen(false);
      setImageUrl("");
      setFileList([]);
      setErrorMsg("");
      setClickNumber("");
      setActiveTab(2);
      setCustomStartDate("");
      setCustomEndDate("");
      setSelectedDates(null);
      setConfirmLoading(false);
    } else {
      setErrorMsg("Component with this name already exists.");
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    props.setIsTrendingProductsModalOpen(false);
    setIsShoplinksModalOpen(false);
    setClickNumber("");
    setImageUrl("");
    setFileList([]);
    setErrorMsg("");
  };

  const handlePrevious = () => {
    setIsShoplinksModalOpen(true);
    props.setIsTrendingProductsModalOpen(false);
    setClickNumber("");
    setImageUrl("");
    setFileList([]);
    setErrorMsg("");
  };

  const handleInputChange = (value: string, setter: Function) => {
    const numericValue = parseInt(value, 10);
    if (numericValue < 1) {
      setErrorMsg("Number should not be less than 1");
      setter(""); // Clear invalid input
    }
    //  else if (numericValue > maxCount) {
    //   setErrorMsg(`Number should not exceed ${maxCount}`);
    // } 
    else {
      setErrorMsg("");
      setIsButtonDisabled(!value);
      setter(value);
    }
  };

  useEffect(() => {
    setActiveTab(2);
    setSelectedDates(null);
    setCustomStartDate("");
    setCustomEndDate("");
  }, [isTrendingProductsModalOpen]);
  return (
    <>
      <Modal
        // title={
        //   <div className="modal-title">
        //     <button onClick={handlePrevious} className="newbutton">
        //       <FaArrowLeft />
        //     </button>
        //   </div>
        // }
        open={isTrendingProductsModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
        okText="Add"
        okButtonProps={{ disabled: !clickNumber  }}
        data-testid="trending-product-carousel"
        width={600}
        centered
        className="add-to-page-modal"
        closeIcon={<span className="modal-close-icon">×</span>}
      >
        <ModalBackButton
          handlePrevious={handlePrevious}
          title="Create a Trending Products Carousel"
          description="Use the options below to filter trending products based on a specific time frame and the number of times the shop button is clicked after which a product is considered trending. This will help you showcase the most relevant products that are gaining popularity"
        />

        <div style={{ marginTop: '24px' }}>
          {/* Trending Period Section */}
          <div style={sectionStyle}>
            <Title level={5} style={{ margin: 0 }}>Date Range for Trending</Title>
          </div>
          <Text style={helperTextStyle}>
            Set the time wondow for tracking trending Activity.
          </Text>

          <CustomDateRange
            localActiveTab={activeTab}
            setLocalActiveTab={setActiveTab}
            setIsCustomDateModalOpen={setIsCustomDateModalOpen}
            isCustomDateModalOpen={isCustomDateModalOpen}
            setSelectedDates={setSelectedDates}
            setCustomStartDate={setCustomStartDate}
            setCustomEndDate={setCustomEndDate}
            selectedDates={selectedDates}
            setDays={setDays}
            customStartDate={customStartDate}
            customEndDate={customEndDate}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
          />

          {/* Shop Button Click Threshold Section */}
          <div style={{ ...sectionStyle, marginTop: '24px' }}>
            <Title level={5} style={{ margin: 0 }}>Minimum Clicks to Trend</Title>
          </div>
          <Text style={helperTextStyle}>
            How many clicks clicks a product needs to qualify as trending.
          </Text>

          <Input
            placeholder="Enter Number of Clicks"
            id="clicks"
            value={clickNumber}
            type="number"

            onChange={(e: any) => {
              handleInputChange(e.target.value, setClickNumber);
            }}
            className="trending-input-box"
          />

          {errorMsg && <Text type="danger" style={{ display: 'block', marginTop: '8px' }}>{errorMsg}</Text>}
        </div>
        <label className="bold-label mt-4">Preview</label>
        <PreviewComponent
          numberOfDays={0}
          username={username}
          user_id={user_id}
          displayName={name}
          type={"trending products"}
          title={name}
          isLoading={TrendingProductsLoading}
          data={TrendingProducts}
        />
      </Modal>
    </>
  );
};

export default TrendingProductsComponent;
